import { sound } from '@pixi/sound';
import * as PIXI from 'pixi.js';
import { PixiBase } from 'bog-arcade-core-ui';
import { gameService } from '../apiServices/GameService';

const SoundTypes = {
  SingleClick: 'SOUND_TYPES_SINGLE_CLICK',
  MainBackground: 'SOUND_TYPES_MAIN_BACKGROUND',
  BonusBackground: 'SOUND_TYPES_BONUS_PRE_BONUS_BACKGROUND',
  Spin: 'SOUND_TYPES_SPIN',
  BetAmountChange: 'SOUND_TYPES_BET_AMOUNT_CHANGE',
  BreakStone: 'SOUND_TYPES_BREAK_STONE',
  CrackStone: 'SOUND_TYPES_CRACK_STONE',
  DragonSound: 'SOUND_TYPES_DRAGON_SOUND',
  Multiplier: 'SOUND_TYPES_MULTIPLIER',
  Move: 'SOUND_TYPES_MOVE',
};

const soundResources = [
  { name: SoundTypes.SingleClick, path: 'sounds/single_click.wav' },
  { name: SoundTypes.MainBackground, path: 'sounds/background_main.mp3' },
  { name: SoundTypes.BonusBackground, path: 'sounds/background_bonus.mp3' },
  { name: SoundTypes.Spin, path: 'sounds/spin.mp3' },
  { name: SoundTypes.BetAmountChange, path: 'sounds/bet_amount_change.mp3' },
  { name: SoundTypes.BreakStone, path: 'sounds/break_stone.mp3' },
  { name: SoundTypes.CrackStone, path: 'sounds/crack_stone.mp3' },
  { name: SoundTypes.DragonSound, path: 'sounds/dragon_fire.mp3' },
  { name: SoundTypes.Multiplier, path: 'sounds/multiplier.mp3' },
  { name: SoundTypes.Move, path: 'sounds/move_sound.mp3' },
];

class PixiSoundService extends PixiBase {
  constructor() {
    super();
    console.log(this.PIXI);
    this.loader = new PIXI.Loader();
    this.state = new Set();
    this._texture = {};
  }

  async init(mute) {
    soundResources.forEach(({ name, path }) => {
      sound.add(name, path);
    });
    if (mute) {
      this.mute();
    }
    return this.loadResource(soundResources, this.loader);
  }

  mute() {
    sound.muteAll();
  }

  unmute() {
    sound.unmuteAll();
  }

  play(name, loop = false) {
    this._texture[name] = true;
    sound.play(name, { loop });
  }

  stop(name) {
    if (this._texture[name]) {
      this._texture[name] = false;
      sound.stop(name);
      if (this.state.has(name)) {
        this.state.delete(name);
      }
    }
  }

  playMainSceneBackground() {
    this.stop(SoundTypes.BonusBackground);
    this.play(SoundTypes.MainBackground, true);
  }

  playBonusSceneBackground() {
    this.stop(SoundTypes.MainBackground);
    // this.play(SoundTypes.BonusBackground, true);
  }

  playSpin() {
    this.play(SoundTypes.Spin);
  }

  playBetAmountChange() {
    this.play(SoundTypes.BetAmountChange);
  }

  playSpinCountChange() {
    this.play(SoundTypes.BetAmountChange);
  }

  playSingleClick() {
    this.play(SoundTypes.SingleClick);
  }

  playCrackStone() {
    this.play(SoundTypes.CrackStone);
  }

  playBreakStone() {
    this.play(SoundTypes.BreakStone);
  }

  playDragonSound() {
    this.play(SoundTypes.DragonSound);
  }

  playMultiplierSound() {
    if(gameService.isBonus){
      this.play(SoundTypes.Multiplier);
    }
  }

  playMoveSound() {
    this.play(SoundTypes.Move);
  }
}

export const soundService = new PixiSoundService();
